(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    class CurveviaBuyNow extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-buy-now-button]');
      this.label = this.querySelector('[data-buy-now-label]');
      this.defaultLabel = this.label?.textContent?.trim() || '';

      if (!this.button || this.dataset.ready === 'true') return;

      this.dataset.ready = 'true';
      this.button.addEventListener('click', this.handleClick);
      window.addEventListener('pageshow', this.handlePageShow);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick);
      window.removeEventListener('pageshow', this.handlePageShow);
    }

    handlePageShow = () => {
      this.setLoading(false);
    };

    handleClick = () => {
      const form = this.closest('form');
      if (!form || !form.reportValidity()) return;

      try {
        const formData = new FormData(form);
        const variantId = String(formData.get('id') || '');
        const quantityValue = Number(formData.get('quantity') || 1);
        const quantity = Math.max(1, Math.trunc(quantityValue));

        if (!/^\d+$/.test(variantId) || !Number.isFinite(quantityValue)) {
          throw new Error('Invalid product selection');
        }

        const properties = {};

        for (const [name, value] of formData.entries()) {
          const match = name.match(/^properties\[(.+)\]$/);
          if (!match) continue;
          if (value instanceof File && value.size > 0) throw new Error('File properties are not supported');
          if (typeof value !== 'string' || value.trim() === '') continue;
          properties[match[1]] = value;
        }

        const root = window.Shopify?.routes?.root || '/';
        const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
        const parameters = new URLSearchParams();

        if (Object.keys(properties).length > 0) {
          const bytes = new TextEncoder().encode(JSON.stringify(properties));
          let binary = '';

          for (const byte of bytes) binary += String.fromCharCode(byte);

          const encodedProperties = btoa(binary)
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/g, '');
          parameters.set('properties', encodedProperties);
        }

        this.setLoading(true);

        const query = parameters.size > 0 ? `?${parameters.toString()}` : '';
        window.location.assign(`${normalizedRoot}cart/${variantId}:${quantity}${query}`);
      } catch {
        this.setLoading(false);
        this.announceError();
      }
    };

    setLoading(isLoading) {
      if (!this.button) return;

      this.button.disabled = isLoading;
      this.button.setAttribute('aria-busy', String(isLoading));

      if (this.label) {
        this.label.textContent = isLoading ? this.button.dataset.loadingText || this.defaultLabel : this.defaultLabel;
      }
    }

    announceError() {
      const liveRegion = this.closest('product-form-component')?.querySelector('[ref="liveRegion"]');
      if (liveRegion) liveRegion.textContent = this.dataset.errorText || '';
    }
  }

  if (!customElements.get('curvevia-buy-now')) {
    customElements.define('curvevia-buy-now', CurveviaBuyNow);
  }
  } catch(e) { console.error(e); }
})();

})();
